import { gql } from '@apollo/client';
export const SourceFragment = gql`
  fragment ClientSourceFields on Source {
    slug
    url
    imageUrl
    image {
      url
    }
    article
    callToAction
    subtitle
    reviewStatus
    __typename
    sys {
      id
    }
  }
`;
export const PodcastFragment = gql`
  fragment PodcastFields on Podcast {
    sys {
      id
    }
    slug
    title
    image {
      url
    }
    imageUrl
    shortDescription
    reviewStatus
    __typename
  }
`;
export const VideoFragment = gql`
  fragment VideoFields on Video {
    sys {
      id
    }
    slug
    title
    image {
      url
    }
    imageUrl
    shortDescription
    reviewStatus
    __typename
  }
`;
export const AppsFragment = gql`
  fragment ApplicationFields on Application {
    sys {
      id
    }
    slug
    name
    image {
      url
    }
    shortDescription
    imageUrl
    reviewStatus
    __typename
  }
`;
export const FontsFragment = gql`
  fragment FontsFields on Fonts {
    stylesheet {
      url
    }
    __typename
    sys {
      id
    }
  }
`;

export const ActivityFragment = gql`
  fragment ClientActivityFields on Activity {
    url
    imageUrl
    image {
      url
    }
    name
    slug
    callToAction
    shortDescription
    reviewStatus
    inCrisisOrder
    __typename
    sys {
      id
    }
  }
`;

export const ServiceFragment = gql`
  fragment ClientServiceFields on Services {
    url
    imageUrl
    image {
      url
    }
    name
    slug
    callToAction
    subtitle
    reviewStatus
    homeOrder
    resourceOrder
    show
    inCrisisOrder
    __typename
    sys {
      id
    }
  }
`;

export const LinkFragment = gql`
  fragment ClientLinkFields on Link {
    title
    subtitle
    url
    callToAction
    reviewStatus
    image {
      url
    }
    show
    resourceOrder
    contactInfo
    contactInfoType
    contactInfoLink
    contactInfoCopy {
      json
    }
    readMoreReference {
      sys {
        id
      }
    }
    highlights
    sys {
      id
    }
    __typename
  }
`;

export const LandingFragment = gql`
  fragment LandingFields on Landing {
    shortName
    slug
    __typename
  }
`;

export const ReferralShowFragment = gql`
  fragment ReferralAssessmentFields on Assessments {
    sys {
      id
    }
  }
  fragment ReferralAssessmentResultsFields on AssessmentResults {
    sys {
      id
    }
  }
  fragment ReferralLandingFields on Landing {
    sys {
      id
    }
  }
`;

export const ReferralClientFragment = gql`
  fragment ReferralClientFields on Client {
    shortName
  }
  fragment ReferralClientGroupFields on ClientGroup {
    shortName
  }
`;
